import Image from 'next/image';
import React from 'react';
import { cx } from '@emotion/css';

type Props = {
  styles: any;
  title: string;
  para1: string;
  para2?: string;
  imageSrc?: string;
  imageAlt?: string;
};
export const EmergencyComponent = (props: Props) => {
  const { styles, title, para1, para2, imageSrc, imageAlt } = props;
  return (
    <section className={styles.emergency}>
      <div className={cx(styles.container, styles.root)}>
        <div className={styles.heading_wraper}>
          <h3 className={cx(styles.site_title, styles.h3)}>{title}</h3>
          <div className={styles.heading_wraper_p}>
            <p className={styles.p}>{para1}</p>
            {para2 && (
              <p className={styles.p} style={{ marginTop: 15 }}>
                {para2}
              </p>
            )}
          </div>
        </div>
        {imageSrc && imageAlt && (
          <div className={styles.emergency_figure}>
            <Image
              src={imageSrc}
              width="1400"
              height="600"
              alt={imageAlt}
              className={styles.emergency_figure_img}
            />
          </div>
        )}
      </div>
    </section>
  );
};
